interface NotificationDotProps {
    className?: string;
    size?: "small" | "medium" | "large";
}

export default function NotificationDot({
    className,
    size = "medium",
}: NotificationDotProps) {
    const sizeClasses = {
        small: "h-3 w-3",
        medium: "h-4 w-4",
        large: "h-6 w-6",
    };

    return (
        <span
            className={`inline-flex rounded-full bg-red-500 ${sizeClasses[size]} ${className}`}
        />
    );
}
